window.arrecadePontualPage = {
    behaviors: () => {

        let startHere = $(".start-here-target");

        $('html, body').animate({
            scrollTop: startHere && startHere.offset() ? startHere.offset().top : 0 - 81
        }, 2000);
    },
    eventBinds: () => {
        App.bindEvent('submit-form', 'click', function (e) {
            arrecadePontualPage.submitForm();
        });
    },
    maskInputs: () => {
        // if ($('.phone_number_mask').length > 0) {
        //     const SPMaskBehavior = function (val) {
        //             return (val.replace(/\D/g, '').length === 11) ? '(00) 00000-0000' : '(00) 0000-00009';
        //         },
        //         spOptions = {
        //             onKeyPress: function (val, e, field, options) {
        //                 field.mask(SPMaskBehavior.apply({}, arguments), options);
        //             }
        //         };
        //
        //     $('.phone_number_mask').mask(SPMaskBehavior, spOptions);
        // }
        if ($('.money').length > 0) {
            $('.money').mask('000.000.000.000.000', {reverse: true});
        }
    },
    limitValidators: () => {
        if ($('#formNovoProjeto, #formEtapa2Projeto').length > 0) {
            if ($('#npNome').length > 0) {
                $('#npNome').limit(40, '#countNomeProjeto');
            }
            if ($('#npComoChegouBenfeitoria').length > 0) {
                $('#npComoChegouBenfeitoria').limit('200', '#countComoChegouBenfeitoria');
            }
            if ($('#npResumoAtividade').length > 0) {
                $('#npResumoAtividade').limit('160', '#countResumoAtividade');
            }
            if ($('#npMaisSobre').length > 0) {
                $('#npMaisSobre').limit('500', '#countMaisSobre');
            }
            if ($('#npMeta1ObjetivosValor').length > 0) {
                $('#npMeta1ObjetivosValor').limit('190', '#countMeta1ObjetivosValor');
                $('#npMeta2ObjetivosValor').limit('190', '#countMeta2ObjetivosValor');
                $('#npMeta3ObjetivosValor').limit('190', '#countMeta3ObjetivosValor');
            }
            let themesLimit = 3;
            $("input[name='temas[]']").on('change', function (evt) {
                if ($("input[name='temas[]']:checked").length > themesLimit) {
                    this.checked = false;
                }
            });
        }
    },
    submitForm: () => {
        const form = $('#formNovoProjeto');

        form.validate({
            ignore: [],
            focusInvalid: false,
            invalidHandler: function (form, validator) {

                if (!validator.numberOfInvalids()) {
                    return;
                }


                let errList = $(validator.errorList[0].element).offset().top;


                    $('html, body').animate({
                        scrollTop: errList > 0 ? errList - 105 : $('.confirm').offset().top - 105
                    }, 2000);



            },
            showErrors: function (errorMap, errorList) {
                const errors = this.numberOfInvalids(); // <- NUMBER OF INVALIDS
                $("#num_invalids").html(errors);
                let fieldsInTabs = [];
                fieldsInTabs['meta1_valor'] = 'meta1'; // tab index
                fieldsInTabs['meta1_objetivos_valor'] = 'meta1';
                let arrayKeys = Object.keys(fieldsInTabs);
                $.each(errorMap, function (key, value) {
                    if (arrayKeys.includes(key)) {
                        let tabIndex = fieldsInTabs[key];
                        if (tabIndex) {
                            $('#tabs a[href="#' + tabIndex + '"]').tab('show');
                        }
                    }
                });
                this.defaultShowErrors(); // <- ENABLE default MESSAGES
            },
            rules: {
                email: {
                    required: true,
                    email: true
                },
                cpf: {
                    required: function (element) {
                        return $('input[name=tipo]').val() == 'PF';
                    },
                    cpf: true
                },
                cnpj: {
                    required: function (element) {
                        return $('input[name=tipo]').val() == 'PJ';
                    },
                    cpnj: true
                },
                // telefone_principal: {
                //     required: true,
                //     telefone_brasileiro: true
                // },
                birthday: {
                    required: function (element) {
                        return $('input[name=tipo]').val() == 'PF';
                    },
                    dateBR: function (element) {
                        return $(element).attr('type') != 'hidden';
                    }
                },
                como_chegou_benfeitoria: {
                    required: true,
                    maxlength: 200
                },
                sobre_voce: {
                    required: true,
                    maxlength: 200
                },
                nome_projeto: {
                    required: true
                },
                resumo_projeto: {
                    required: true,
                    maxlength: 160
                },
                mais_sobre: {
                    required: true,
                    maxlength: 500
                },
                meta1_valor: {
                    required: true,
                    goalMinimunAmount:true
                },
                meta2_valor: {
                    number: true,
                    goalThreshold: ["Meta 1",'#meta1_valor']
                },
                meta3_valor: {
                    number: true,
                    goalThreshold: ["Meta 2",'#meta2_valor']
                },
                meta1_objetivos_valor: {
                    required: true,
                    maxlength: 200
                },
                check_confirmacao_final: {
                    required: true
                }
            },
            messages: {
                cpf: {
                    cpf: 'CPF inválido'
                },
                birthday: {
                    dateBR: 'Data inválida'
                },
                // telefone_principal: {
                //     phone: 'Telefone inválido'
                // }
            },
            errorElement: 'span',
            errorPlacement: function (error, element) {
                if (element.parent().parent().attr('class') == 'optionBox') {
                    error.prependTo(element.parent().parent().parent());
                } else if (element.parent().parent().parent().hasClass('optionBox secondOne')) {
                    error.prependTo(element.parent().parent().parent());
                } else if (element.parent().hasClass('input-group')) {
                    error.prependTo(element.parent().parent().parent());
                } else {
                    error.prependTo(element.parent());
                }
            }
        });
        if (form.valid()) {
            $('#btnEnviar').prop('disabled', true);
            $('#btnEnviar').val('Aguarde...');
            form.submit();
        }
    },
    load: () => {
        arrecadePontualPage.maskInputs();
        arrecadePontualPage.limitValidators();
        arrecadePontualPage.eventBinds();
        arrecadePontualPage.behaviors();
    }
};
if($('#current_page').val() === "v2-arrecade") arrecadePontualPage.load();